import { render, staticRenderFns } from "./body-icon-2.vue?vue&type=template&id=6f53ca7e&"
import script from "./body-icon-2.vue?vue&type=script&lang=js&"
export * from "./body-icon-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports